import clamp from "clamp";

export function initHomeHero(wrapper: HTMLDivElement, scrollLength: number) {

	window.addEventListener('scroll', () => {
		let ratio = clamp(window.scrollY / scrollLength, 0, 1);
		wrapper.style.setProperty('--fx-progress', ratio.toFixed(3));
	})

}
